import { ComboForceLayout } from '@antv/layout/lib/layout/comboForce';

export default ComboForceLayout;
